import { StoreTenant } from '@/src/lib/store/types';

// API
export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const SPRYKER_CDN_URL = process.env.NEXT_PUBLIC_SPRYKER_CDN_URL;

// Auth0
export const APP_BASE_URL = process.env.APP_BASE_URL || process.env.NEXT_PUBLIC_SELF_URL;
export const AUTH0_SCOPE = process.env.AUTH0_SCOPE;
export const AUTH0_DOMAIN = process.env.AUTH0_DOMAIN;
export const AUTH0_AUDIENCE = process.env.AUTH0_AUDIENCE;
export const AUTH0_CLIENT_ID = process.env.AUTH0_CLIENT_ID;
export const AUTH0_SECRET = process.env.AUTH0_SECRET;
export const AUTH0_CLIENT_SECRET = process.env.AUTH0_CLIENT_SECRET;

// Sentry
export const SENTRY_AUTH_TOKEN = process.env.SENTRY_AUTH_TOKEN;
export const SENTRY_ORG = process.env.SENTRY_ORG;
export const SENTRY_PROJECT = process.env.SENTRY_PROJECT;
export const SENTRY_ENVIRONMENT = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT;
export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

// Stripe
export const STRIPE_PUBLISHABLE_KEY = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;

// Unleash
export const UNLEASH_SERVER_API_URL = process.env.UNLEASH_SERVER_API_URL;
export const UNLEASH_SERVER_API_TOKEN = process.env.UNLEASH_SERVER_API_TOKEN;
export const UNLEASH_FRONTEND_API_URL = process.env.NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL;
export const UNLEASH_FRONTEND_API_TOKEN = process.env.NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN;
export const UNLEASH_SERVER_INSTANCE_ID = process.env.UNLEASH_SERVER_INSTANCE_ID;
export const UNLEASH_ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT;
export const REQUEST_FLAG_SERVICE = process.env.NEXT_PUBLIC_REQUEST_FLAG_SERVICE;

// Google
export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;

// Vercel
export const VERCEL_URL = process.env.VERCEL_URL;
export const VERCEL_ENV = process.env.NEXT_PUBLIC_VERCEL_ENV || 'local';
export const VERCEL = process.env.VERCEL;
export const EDGE_CONFIG = process.env.EDGE_CONFIG;

// General
export const TENANT: StoreTenant = process.env.NEXT_PUBLIC_TENANT as StoreTenant;
export const BASIC_AUTH_USER = process.env.NEXT_BASIC_AUTH_USER;
export const BASIC_AUTH_PASS = process.env.NEXT_BASIC_AUTH_PASS;
export const NODE_ENV = process.env.NODE_ENV;
export const NEXT_RUNTIME = process.env.NEXT_RUNTIME;
export const REQUEST_OFFER_MAIL = process.env.NEXT_PUBLIC_REQUEST_OFFER_MAIL || '';
export const SUPPORT_MAIL = process.env.NEXT_PUBLIC_SUPPORT_MAIL || '';
export const GIT_COMMIT_SHA = process.env.NEXT_PUBLIC_GIT_COMMIT_SHA ?? 'local';
export const SELF_URL =
  process.env.NEXT_PUBLIC_SELF_URL || process.env.NEXT_PUBLIC_VERCEL_URL || process.env.VERCEL_URL;
export const LOGGING = process.env.NEXT_PUBLIC_LOGGING === 'true' || process.env.NEXT_PUBLIC_LOGGING === '1';
export const E2E_TESTS_BRANCH_NAME = process.env.UPSTREAM_BRANCH_OR_MAIN;
